/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';

import './skeleton.css';

export default function SkeletonCard() {
  return (
    <div className="skeleton-container">
      <section className="skeleton-card">
        <figure className="skeleton-card-image skeleton-loading" />
        <div className="skeleton-card-detail">
          <h3 className="skeleton-card-title skeleton-loading" />
          <p className="skeleton-card-description  skeleton-loading" />
        </div>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/SkeletonCard.js